export const safeParse = str => {
  try {
    return JSON.parse(str || 'null');
  } catch (e) {
    console.log('Could not parse JSON:', e);
    return { error: str };
  }
};
